import { Locations } from "../../../models/state/locations/Locations";
import * as locationSelectors from "./location";

export const getLocation = (state: Locations, locationId: string) =>
  state.get(locationId);

export const getLocationId = (state: Locations, locationId: string) =>
  locationSelectors.getId(getLocation(state, locationId)!);

export const getLocationName = (state: Locations, locationId: string) =>
  locationSelectors.getName(getLocation(state, locationId)!);

export const getLocationCountryName = (state: Locations, locationId: string) =>
  locationSelectors.getCountryName(getLocation(state, locationId)!);

export const getLocationImageUrl = (state: Locations, locationId: string) =>
  locationSelectors.getImageUrl(getLocation(state, locationId)!);

export const getLocationLatitude = (state: Locations, locationId: string) =>
  locationSelectors.getLatitude(getLocation(state, locationId)!);

export const getLocationLongitude = (state: Locations, locationId: string) =>
  locationSelectors.getLongitude(getLocation(state, locationId)!);
